import { Button, ButtonProps } from "@mui/material";
import TooltipComponent from "./TooltipComponent";
import { t } from 'i18next';
import { Info } from "@mui/icons-material";

export default function InfoButton(props: ButtonProps) {
    return (
        <Button {...props}>
            <TooltipComponent title={t("Details") + ""}>
                <Info />
            </TooltipComponent>
        </Button>
    )
}